// extracted by mini-css-extract-plugin
module.exports = {"AdSlotBranding__desktopWrap":"bgb_a","AdSlotBranding__desktop":"bgb_b","AdSlotBranding__mobile":"bgb_c"};